import {
  ConsumerEvent,
  HandshakeEvent,
  HandshakeEvent_Deprecated,
  HostEvent,
} from './events';
import {
  AbstractHandshake,
  IOnMessage,
  IPostMessage,
} from './AbstractHandshake';

export class HostHandshake extends AbstractHandshake {
  #messageChannel?: MessageChannel;

  constructor(postMessage: IPostMessage, onMessage: IOnMessage) {
    super(postMessage, onMessage);

    this.#initHandshake();
    this.#onConsumerPing();
  }

  #initHandshake() {
    this.onMessage((event) => {
      try {
        const payload: ConsumerEvent = JSON.parse(event.data);

        switch (payload.type) {
          case HandshakeEvent.Ping: {
            this.#onConsumerPing();
            break;
          }

          case HandshakeEvent.RequestPort: {
            this.#onConsumerRequestPort(payload.memberId);
            break;
          }

          /**
           * @deprecated
           * backward compatibility
           */
          case HandshakeEvent_Deprecated.Greeting: {
            if (!payload?.memberId && payload?.memberId === 'host') {
              return;
            }

            this.postMessage(
              JSON.stringify({
                memberId: 'host',
                type: HandshakeEvent_Deprecated.Greeting,
              }),
            );
            break;
          }

          /**
           * @deprecated
           * backward compatibility
           */
          case HandshakeEvent_Deprecated.RequestPort: {
            const messageChannel = this.#createMessageChannel();
            this.setActivePort(messageChannel?.port1);

            this.postMessage(
              JSON.stringify({
                memberId: 'host',
                targetMemberId: payload.memberId,
                type: HandshakeEvent_Deprecated.Port,
              }),
              messageChannel.port2,
            );
            break;
          }
        }
      } catch (e) {
        // skip unnecessary events
      }
    });
  }

  #onConsumerPing() {
    const payload: HostEvent = {
      type: HandshakeEvent.Pong,
    };

    this.postMessage(JSON.stringify(payload));
  }

  #onConsumerRequestPort(memberId: string) {
    const messageChannel = this.#createMessageChannel();
    this.setActivePort(messageChannel?.port1);

    const payload: HostEvent = {
      type: HandshakeEvent.Port,
      targetMemberId: memberId,
    };

    this.postMessage(JSON.stringify(payload), messageChannel.port2);
  }

  #createMessageChannel() {
    if (this.#messageChannel) {
      this.#messageChannel.port1.close();
      this.#messageChannel.port1.onmessage = null;
    }

    this.#messageChannel = new MessageChannel();
    return this.#messageChannel;
  }
}
